import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useNavigate} from 'react-router-dom';
import {usePatientsContext} from 'context/patient_context';
import editPatientProfile from 'api/editPatientProfile';
import {queryKeys} from 'react-query/constant';

const useEditPatientProfile = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const {handleOpenSnackbar} = usePatientsContext();
  const mutateReminder = useMutation({
    mutationFn: editPatientProfile,
    onSuccess: (res) => {
      if (res.status === 200) {
        queryClient.invalidateQueries({
          queryKey: [queryKeys.patientInfo],
          exact: true,
        });
        handleOpenSnackbar('اطلاعات با موفقیت ثبت شد');
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      }
    },
    onError: (error) => {
      handleOpenSnackbar(error.response.data.messages, 'error');
    },
  });
  return mutateReminder;
};

export default useEditPatientProfile;
